import { Col, Row } from 'reactstrap';

import InviteMemberModal from './InviteMemberModal';
import BulkInviteMembers from './InviteBulkMembers';

const InvitMemberWrapper = ({ pushNewMember }) => {
  return (
    <>
      <Row>
        <Col md="6" className="pr-md-3 border-right">
          <InviteMemberModal pushNewMember={pushNewMember} />
        </Col>
        <Col md="6" className="pl-md-3">
          <BulkInviteMembers pushNewMember={pushNewMember} />
        </Col>
      </Row>
    </>
  );
};

export default InvitMemberWrapper;
